


























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { FaqRequestModel } from '@/modules/faq/models/faq-request.model'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import collect from 'collect.js'
import { FaqType } from '@/modules/faq/models/faq-resource.model'

@Component({
  components: { BaseSelect, BaseInput }
})
export default class AdminFaqForm extends Vue {

  @ModelSync('value', 'input') faq!: FaqRequestModel
  @Prop() types: { [key in FaqType]: string }

  get typeOptions() {
    return collect(this.types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }
}
